import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	fade,
	makeStyles,
	TextField,
} from "@material-ui/core";
import ConfirmIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/ErrorOutline";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import classnames from "classnames";
import React, { useState } from "react";
import {
	Button as RaButton,
	Confirm,
	useNotify,
	useRefresh,
	useTranslate,
	useUnselectAll,
	useUpdateMany,
} from "react-admin";

const useStyles = makeStyles(
	(theme) => ({
		confirmPrimary: {
			color: theme.palette.primary.main,
		},
		confirmWarning: {
			color: theme.palette.error.main,
			"&:hover": {
				backgroundColor: fade(theme.palette.error.main, 0.12),
				// Reset on mouse devices
				"@media (hover: none)": {
					backgroundColor: "transparent",
				},
			},
		},
		iconPaddingStyle: {
			paddingRight: "0.5em",
		},
	}),
	{ name: "RaConfirm" }
);

const RejectButton = ({ selectedIds }) => {
	const confirmColor = "primary";
	const classes = useStyles();
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();
	const unselectAll = useUnselectAll();
	const [isOpen, setIsOpen] = useState(false);
	const [supervisorNotes, setSupervisorNotes] = useState("");
	const status = "rejected";
	const [updateMany, { loading }] = useUpdateMany(
		"bookmaker-approvals",
		selectedIds,
		{ status, supervisor_notes: supervisorNotes },
		{
			onSuccess: () => {
				notify(translate(`resources.bookmaker-approvals.messages.${status}`));
				unselectAll("bookmaker-approvals");
				refresh();
				handleClose();
			},
			onError: () => {
				notify(translate("resources.bookmaker-approvals.messages.error"));
			},
		}
	);

	const handleClose = () => setIsOpen(false);
	const handleOpen = () => setIsOpen(true);

	return (
		<>
			<Confirm
				isOpen={isOpen}
				loading={loading}
				title={translate("resources.bookmaker-approvals.actions.reject.title")}
				content={translate(
					"resources.bookmaker-approvals.actions.reject.content_2"
				)}
				onConfirm={updateMany}
				onClose={handleClose}
			/>
			<Dialog open={isOpen} onClose={handleClose}>
				<DialogTitle>
					{translate("resources.bookmaker-approvals.actions.reject.title")}
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{translate("resources.bookmaker-approvals.actions.reject.content")}
					</DialogContentText>
					<TextField
						defaultValue={supervisorNotes}
						onChange={(e) => setSupervisorNotes(e.target.value)}
						autoFocus
						margin="dense"
						id="supervisor_notes"
						label={translate(
							"resources.bookmaker-approvals.fields.supervisor_notes"
						)}
						multiline
						rows={5}
						fullWidth
					/>
				</DialogContent>
				<DialogActions>
					<Button disabled={loading} onClick={handleClose}>
						<CancelIcon className={classes.iconPaddingStyle} />
						{translate("ra.action.cancel")}
					</Button>
					<Button
						disabled={loading}
						onClick={updateMany}
						className={classnames("ra-confirm", {
							[classes.confirmWarning]: confirmColor === "warning",
							[classes.confirmPrimary]: confirmColor === "primary",
						})}
						autoFocus
					>
						<ConfirmIcon className={classes.iconPaddingStyle} />
						{translate("resources.bookmaker-approvals.actions.reject.confirm")}
					</Button>
				</DialogActions>
			</Dialog>
			<RaButton
				onClick={handleOpen}
				label={translate("resources.user-payments.buttons.reject")}
			>
				<ThumbUpAltIcon />
			</RaButton>
		</>
	);
};

export default RejectButton;
